var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRingcentralForSymphony = function SvgRingcentralForSymphony(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF7A00",
    d: "M18.656 0H5.344A5.344 5.344 0 0 0 0 5.344v13.312A5.344 5.344 0 0 0 5.344 24h13.312A5.344 5.344 0 0 0 24 18.656V5.344A5.344 5.344 0 0 0 18.656 0M5.344 2.063h13.312a3.28 3.28 0 0 1 3.282 3.28v13.313a3.28 3.28 0 0 1-3.282 3.282H5.344a3.28 3.28 0 0 1-3.282-3.282V5.344a3.28 3.28 0 0 1 3.282-3.282"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M5.344 2.063h13.312a3.28 3.28 0 0 1 3.282 3.28v13.313a3.28 3.28 0 0 1-3.282 3.282H5.344a3.28 3.28 0 0 1-3.282-3.282V5.344a3.28 3.28 0 0 1 3.282-3.282"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0684BC",
    d: "M8.154 18.794a.34.34 0 0 0 .253-.096.34.34 0 0 0 .098-.253V8.621a.275.275 0 0 1 .31-.312h6.37a.275.275 0 0 1 .302.312v3.067a.273.273 0 0 1-.302.31h-2.87a.275.275 0 0 0-.316.312v1.359q-.008.466.088.921c.066.274.182.534.34.767l1.98 3.106a.7.7 0 0 0 .66.331h2.582q.195 0 .254-.107a.26.26 0 0 0-.04-.261L15.9 15.254q-.135-.194.099-.31l1.377-.621c.443-.18.82-.492 1.078-.894a2.66 2.66 0 0 0 .342-1.391V7.533q0-1.146-.593-1.738-.591-.592-1.738-.592H7.534q-1.122 0-1.727.592-.604.592-.604 1.738v10.912a.34.34 0 0 0 .097.253.34.34 0 0 0 .252.096z"
  }))));
};
export default SvgRingcentralForSymphony;